var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cascader-parser"},[_c('el-cascader',_vm._b({attrs:{"filterable":true},on:{"change":_vm.handleChange},model:{value:(_vm._modelData),callback:function ($$v) {_vm._modelData=$$v},expression:"_modelData"}},'el-cascader',Object.assign({}, _vm.value.props,
      _vm.privateOptions),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }